<template>
  <b-row>
    <b-col :md="4">
      <b-form-group
        id="item-gas-stations-group"
        :label="$t('MENU.ITEM.TANKS.GAS_STATION')"
        label-for="item-gas-stations-input"
      >
        <FormSelect
          id="item-gas-stations-input"
          type="select"
          clearable
          :options="gasStations"
          :value="gasTankStationId"
          @input="$emit('update:gasTankStationId', $event)"
          :validateState="validateState"
        ></FormSelect>
      </b-form-group>
    </b-col>
    <b-col :md="4">
      <b-form-group
        id="item-bill-number-group"
        :label="$t('FORM_LABELS.INVOICE_NUMBER')"
        label-for="bill-invoice-number-input"
      >
        <div class="input-group">
          <FormInput
            id="bill-invoice-number-input"
            type="text"
            name="bill_number"
            :i18n="{
              label: 'FORM_LABELS.INVOICE_NUMBER',
              placeholder: $t('FORM_LABELS.INVOICE_NUMBER')
            }"
            :value="invoiceNumber"
            @input="$emit('update:invoiceNumber', $event)"
            :validateState="invoiceNumberValidateState"
          ></FormInput>
        </div>
      </b-form-group>
    </b-col>
    <b-col :md="4">
      <b-form-group
        id="item-invoice-date-group"
        :label="$t('FORM_LABELS.DATE')"
        label-for="invoice-date-input"
      >
        <FormDatepicker
          id="invoice-date-input"
          type="text"
          :value="invoiceDate"
          @input="$emit('update:invoiceDate', $event)"
          :validateState="invoiceDateValidateState"
        ></FormDatepicker>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import FormInput from "@/view/content/forms/components/FormInput.vue";
import FormDatepicker from "@/view/content/forms/components/FormDatepicker.vue";
import FormSelect from "@/view/content/forms/components/FormSelect.vue";

export default {
  name: "FuelExpenseFormHeader",
  components: {
    FormInput,
    FormDatepicker,
    FormSelect
  },
  props: {
    gasTankStationId: {
      type: [Number, String],
      default: null
    },
    invoiceNumber: {
      type: String,
      default: ""
    },
    invoiceDate: {
      type: String,
      default: ""
    },
    gasStations: {
      type: Array,
      default: () => []
    },
    validateState: {
      type: [Boolean, null],
      default: null
    },
    invoiceNumberValidateState: {
      type: [Boolean, null],
      default: null
    },
    invoiceDateValidateState: {
      type: [Boolean, null],
      default: null
    }
  }
};
</script>
